import type { BlockExportMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ContactBlock } from "./ContactBlock";
import { ContactItemBlock } from "./ContactItemBlock";
import { FaqItemBlock } from "./FaqItemBlock";
import { ItemCardBlock } from "./ItemCardBlock";
import { NumberedCardBlock } from "./NumberedCardBlock";
import { StatCardBlock } from "./StatCardBlock";
import { UserCardBlock } from "./UserCardBlock";
import { UserSatisfactionBlock } from "./UserSatisfactionBlock";

export const sectionBlocks: BlockExportMapping = {
  statCard: StatCardBlock,
  userCard: UserCardBlock,
  numberedCard: NumberedCardBlock,
  faqItem: FaqItemBlock,
  itemCard: ItemCardBlock,
  userSatisfaction: UserSatisfactionBlock,
  contactBlock: ContactBlock,
  contactItem: ContactItemBlock,
};
